import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, Button } from 'react-bootstrap';

const propTypes = {
    show: PropTypes.bool,
    title: PropTypes.string.isRequired,
    messageText: PropTypes.string,
    pairName: PropTypes.string.isRequired,
    confirmButtonText: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};

const defaultProps = {
    messageText: '',
    pairName: '',
    confirmButtonText: 'Confirm',
    show: true,
};

function isValidVariableName(name) {
    try {
        // 1. Check if it's a string and not empty
        if (typeof name !== 'string' || name.trim() === '')
            return false;

    // 2. Reserved words list (ECMAScript 2024+)
    const reservedWords = new Set([
        "break", "case", "catch", "class", "const", "continue", "debugger",
        "default", "delete", "do", "else", "export", "extends", "finally",
        "for", "function", "if", "import", "in", "instanceof", "new",
        "return", "super", "switch", "this", "throw", "try", "typeof",
        "var", "void", "while", "with", "yield", "let", "static", "enum",
        "await", "implements", "interface", "package", "private",
        "protected", "public", "null", "true", "false"
    ]);

    if (reservedWords.has(name))
        return false;

    // 3. Regex for valid JS identifiers
    // Must start with [a-zA-Z$_], followed by [a-zA-Z0-9$_]
    const pattern = /^[a-zA-Z_$][a-zA-Z0-9_$]*$/;
    
    return pattern.test(name);
    } catch (e) {
        return false;
    }
}

class GenericTextInputModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            key_text: '',
            value_text: '',
        };
    }

    onKeyTextChange=(e)=>{
        this.setState({ key_text: e.target.value });
    }

    onValueTextChange=(e)=>{
        this.setState({ value_text: e.target.value });
    }

    submitHandler=(e)=>{
        if (!isValidVariableName(this.state.key_text)) {
            return;
        }
        if (!this.state.key_text || !this.state.value_text) return;
        this.props.onConfirm(this.state.key_text, this.state.value_text);
    }

    render() {
        let invalid_key_text = this.state.key_text && !isValidVariableName(this.state.key_text);
        return (
            <Modal
                show={this.props.show}
                enforceFocus={false}
                backdrop={false}
                animation={false}
                keyboard
                onHide={this.onClose}
            >
                <Modal.Header closeButton onHide={this.props.onClose}>
                    <Modal.Title>{this.props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="message">{this.props.messageText}</div>
                    <Form>
                        <Form.Group>
                            <Form.Label>{'Name:'}</Form.Label>
                            <Form.Control
                                aria-label={this.props.pairName + " name"}
                                value={this.state.key_text}
                                placeholder={`Enter ${this.props.pairName} name`}
                                onChange={this.onKeyTextChange}
                            />
                            { invalid_key_text ?
                            <div className="error-text">invalid key</div>
                            : null }
                            <Form.Label>{'Value:'}</Form.Label>
                            <Form.Control
                                aria-label={this.props.pairName + " value"}
                                value={this.state.value_text}
                                placeholder={`Enter ${this.props.pairName} value`}
                                onChange={this.onValueTextChange}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        onClick={this.submitHandler}
                        disabled={!this.state.key_text || !this.state.value_text}
                    >
                        {this.props.confirmButtonText}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

GenericTextInputModal.propTypes = propTypes;
GenericTextInputModal.defaultProps = defaultProps;

export default GenericTextInputModal;